// apps/web/src/pages/vendas/detalhe/item-acoes-menu.tsx — Fase 12, Plano 31 (PV-07, T-12-46; UI-SPEC § Detalhe do PV).
// Menu "⋯" por item, aberto por clique/toque. A tela só MOSTRA a ação coerente com o estado do item (tem lote?) e a
// permissão; quem decide de verdade é o servidor (409 ITEM_JA_RECEBIDO / ITEM_AINDA_NAO_RECEBIDO).
import { MoreHorizontal } from 'lucide-react';
import type { PedidoVendaItemView } from '@pieltec/contracts';
import { Button } from '../../../components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../components/ui/dropdown-menu';
import { acoesDoItem, type AcaoItemPv } from '../../../lib/vendas/ajustes';

export type { AcaoItemPv };

export const ROTULO_ACAO_ITEM: Record<AcaoItemPv, string> = {
  EDITAR: 'Editar item',
  AJUSTAR: 'Ajustar item recebido',
  ENCERRAR_SALDO: 'Encerrar saldo',
  CANCELAR: 'Cancelar item',
};

/** Corpo do diálogo destrutivo de "Cancelar item" (UI-SPEC § Destructive confirmation). */
export const COPIA_CANCELAR_ITEM = 'Cancelar este item remove o saldo dele do PV. O motivo fica registrado na auditoria. Confirmar cancelamento?';

/** Ações disponíveis para o item conforme o estado (tem lote?) e as permissões do usuário. */
export function acoesDoItemNaTela(item: PedidoVendaItemView, permissoes: readonly string[]): AcaoItemPv[] {
  return acoesDoItem({
    temLote: item.lotes.length > 0,
    cancelado: item.cancelado,
    saldoEncerrado: item.saldoEncerrado,
    saldo: item.saldos.saldo,
    permissoes,
  });
}

interface ItemAcoesMenuProps {
  readonly item: PedidoVendaItemView;
  readonly permissoes: readonly string[];
  readonly onAcao: (item: PedidoVendaItemView, acao: AcaoItemPv) => void;
}

export function ItemAcoesMenu({ item, permissoes, onAcao }: ItemAcoesMenuProps) {
  const acoes = acoesDoItemNaTela(item, permissoes);
  if (acoes.length === 0) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="ghost" size="icon" aria-label={`Mais ações do item ${item.numeroItem}`} className="size-11 sm:size-9">
          <MoreHorizontal aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {acoes.map((acao) => (
          <DropdownMenuItem key={acao} data-acao={acao} onSelect={() => onAcao(item, acao)} className="min-h-10">
            {ROTULO_ACAO_ITEM[acao]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
